import React from 'react'

const CheckboxBlackEmpty = ({}) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">

    <path
      d="M1 2C1 1.44772 1.44772 1 2 1H16C16.5523 1 17 1.44772 17 2V16C17 16.5523 16.5523 17 16 17H2C1.44771 17 1 16.5523 1 16V2Z"
      stroke="#282832"
      strokeWidth="2"
    />

  </svg>
)

export default CheckboxBlackEmpty
